import { css } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../models/NameUtils';
import { Button } from '../../../../web/components-v2/Button';
import { ILeadSearchView } from '../../../viewModels/leads/interfaces';
import { FollowUpDue } from './FollowUpDue';
import { OutcomePill } from '../../../components/OutcomePill';
import { RecordingActions } from './RecordingActions';
import { styleSheet } from './styles';

export const FOLLOW_UP_COLUMNS = ['Company info', 'Follow up', 'Name / description', 'SDR', 'Last call', 'Recording'];

interface IProps {
	lead: ILeadSearchView;
	onOpen: (companyId: string) => void;
}

export const FollowUpRow: React.FC<IProps> = ({ lead, onOpen }) => {
	const companyId = lead.company?.id;
	const companyName = lead.company?.companyName ?? 'Unknown';
	return (
		<div className={css(styleSheet.row, styleSheet.rowGrid)}>
			<div className={css(styleSheet.company)}>
				{companyId ? (
					<Button
						type='button'
						variant='link'
						aria-label={`Open ${companyName}`}
						styles={[styleSheet.openLead, styleSheet.companyName]}
						onClick={() => onOpen(companyId)}
					>
						{companyName}
					</Button>
				) : (
					<span className={css(styleSheet.companyName)}>{companyName}</span>
				)}
				<span className={css(styleSheet.mutedSmall)}>
					{lead.company?.phoneNumbers?.[0]?.metadata?.standard ?? 'Unknown'}
				</span>
			</div>
			<FollowUpDue followUp={lead.followUp} />
			<span className={css(styleSheet.note)}>{lead.followUp?.name}</span>
			<span>{getDisplayName(lead.followUp?.creator)}</span>
			<OutcomePill interaction={lead.lastInteraction} />
			<div className={css(styleSheet.aboveOpenLead, styleSheet.rowActions)}>
				<RecordingActions phoneCall={lead.interactionPhoneCall} variant='row' />
			</div>
		</div>
	);
};
